<template>
	<div class="box-header">
		<div class="title">
			<img class="title-icon" src="../../assets/image/bg_title.png" alt="">
			<span class="title-text">{{title}}</span>
		</div>
		<div class="right">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: '标题'
		}
	}
}
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";
.box-header{
	position: relative;
	z-index: 9;
	height: 60px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	.title{
		display: flex;
		flex-direction: row;
		align-items: center;
		.title-icon{
			width: 74px;
			height: 26px;
		}
		.title-text{
			font-size: 40px;
			font-family: "screen",serif;
			color: #E7F3FF;
			text-shadow:0 0 1em rgba(82,163,255,.56),0 0 1em rgba(82,163,255,.56);
			box-sizing: border-box;
			margin-left: 15px;
		}
	}
	.right{
	}
}
</style>
